import { apiClient } from '@/services/api/client';
import type { ApiResponse } from '@cloudflare-atmb/shared';

export interface RegisterPayload {
    email: string;
    password: string;
    confirmPassword: string;
    realName: string;
    englishName: string;
    gender: string;
    phone: string;
    inviteCode: string;
}

export interface LoginPayload {
    email: string;
    password: string;
}

export interface AuthResponseData {
    token: string;
    user: {
        id: string;
        email: string;
        name: string;
    };
}

export type AuthResponse = ApiResponse<AuthResponseData>;

export const authService = {
    register: async (payload: RegisterPayload): Promise<AuthResponse> => {
        const response = await apiClient.post<any, AuthResponse>('/auth/register', payload);
        return response;
    },

    login: async (payload: LoginPayload): Promise<AuthResponse> => {
        const response = await apiClient.post<any, AuthResponse>('/auth/login', payload);
        return response;
    },

    getCurrentUser: async (): Promise<AuthResponse> => {
        const response = await apiClient.get<any, AuthResponse>('/auth/me');
        return response;
    }
};

